module.exports = __webpack_public_path__ + "1aaebfcf811bbf4f532845594e618874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class/headdemo.png
// module id = 276
// module chunks = 0